webpackJsonp([14],{

/***/ "hQb9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query RakstsQuery($lang: String!, $postId: [Int]!, $parent: [Int]!) {\n    current: page(lang: $lang, _id: $postId) {\n      _id\n      title\n      path\n      parent\n      content\n      date_created\n      date_modified\n      subpages_pages {\n        _id\n        title\n        path\n        parent\n        content\n        acf\n      }\n      acf\n    }\n    parent: page(lang: $lang, _id: $parent) {\n      _id\n      title\n      path\n      subpages_pages {\n        _id\n        title\n        path\n        parent\n        content\n        acf\n      }\n      acf\n    }\n    teksti(lang: $lang, _id:[\n      "publicets",\n      "atjaunots",\n      "atpakal",\n      "talak",\n      "apskatit_attelu_originalizmera"\n    ]) {\n      _id\n      text\n    }\n  }\n'], ['\n  query RakstsQuery($lang: String!, $postId: [Int]!, $parent: [Int]!) {\n    current: page(lang: $lang, _id: $postId) {\n      _id\n      title\n      path\n      parent\n      content\n      date_created\n      date_modified\n      subpages_pages {\n        _id\n        title\n        path\n        parent\n        content\n        acf\n      }\n      acf\n    }\n    parent: page(lang: $lang, _id: $parent) {\n      _id\n      title\n      path\n      subpages_pages {\n        _id\n        title\n        path\n        parent\n        content\n        acf\n      }\n      acf\n    }\n    teksti(lang: $lang, _id:[\n      "publicets",\n      "atjaunots",\n      "atpakal",\n      "talak",\n      "apskatit_attelu_originalizmera"\n    ]) {\n      _id\n      text\n    }\n  }\n']);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _reactRedux = __webpack_require__("RH2O");

var _reactApollo = __webpack_require__("3zLD");

var _LoadingActions = __webpack_require__("tuf/");

var _LoadingActions2 = _interopRequireDefault(_LoadingActions);

var _pages = __webpack_require__("04qB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// FIXME: Identisks ar UznemejiemPostDefault, DomeDefault un PageIzsoles

var QUERY = (0, _graphqlTag2.default)(_templateObject);

var queryOptions = {
  options: function options(_ref) {
    var lang = _ref.lang,
        postId = _ref.postId,
        init_page = _ref.init_page;
    return {
      fetchPolicy: 'cache-first',
      variables: {
        lang: lang || 'lv',
        postId: init_page.rewrite_id ? init_page.rewrite_id : postId,
        parent: init_page.parent,
        path: init_page.path
      }
    };
  },
  props: function props(_props) {
    var _props$data = _props.data,
        loading = _props$data.loading,
        path = _props$data.variables.path,
        current = _props$data.current,
        parent = _props$data.parent,
        teksti = _props$data.teksti,
        rest = _objectWithoutProperties(_props$data, ['loading', 'variables', 'current', 'parent', 'teksti']);

    return {
      loading: loading,
      data: {
        path: path,
        current: current,
        parent: parent,
        subpages: current && current.length ? current[0].subpages_pages : parent && parent.subpages_pages.length ? parent[0].subpages_pages : [],
        teksti: teksti
      }
    };
  }
};

var UznemejiemPostDefault = function (_React$PureComponent) {
  _inherits(UznemejiemPostDefault, _React$PureComponent);

  function UznemejiemPostDefault() {
    _classCallCheck(this, UznemejiemPostDefault);

    return _possibleConstructorReturn(this, (UznemejiemPostDefault.__proto__ || Object.getPrototypeOf(UznemejiemPostDefault)).apply(this, arguments));
  }

  _createClass(UznemejiemPostDefault, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props2 = this.props,
          path = _props2.path,
          loading = _props2.loading,
          loadingStatuss = _props2.loadingStatuss,
          global_loading = _props2.global_loading;


      if (loading) {
        loadingStatuss({ _id: path + '__', loading: true });
      } else if (!loading && global_loading && global_loading[path + '__'] === true) {
        loadingStatuss({ _id: path + '__', loading: false });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var path = nextProps.path,
          loading = nextProps.loading,
          loadingStatuss = nextProps.loadingStatuss,
          global_loading = nextProps.global_loading;


      if (loading && global_loading && global_loading[path + '__'] === false) {
        loadingStatuss({ _id: path + '__', loading: true });
      } else if (!loading && global_loading && global_loading[path + '__'] === true) {
        loadingStatuss({ _id: path + '__', loading: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          loading = _props3.loading,
          data = _props3.data,
          lang = _props3.lang,
          history = _props3.history;


      if (loading) {
        return null;
      }

      return _react2.default.createElement(_pages.Raksts, { data: data, lang: lang, path: history.location.pathname });
    }
  }]);

  return UznemejiemPostDefault;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    global_loading: state.global_loading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadingStatuss: function loadingStatuss(LOADING) {
      dispatch((0, _LoadingActions2.default)(LOADING));
    }
  };
};

exports.default = (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(UznemejiemPostDefault);

/***/ })

});


// WEBPACK FOOTER //
// UznemejiemPostDefault.804a967b1a3f32b6d19a.js